import React from 'react'
import PropTypes from 'prop-types'
import StickyHeader from 'components/StickyHeader'
import Icon from 'components/common/Icon/Icon'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'

const OneColumnGenericPage = ({ placeholders: { footer, header, genericMainContent }, pathname }) =>
  <div>
    <StickyHeaderWrapper>
      { header }
      <StickyHeader data-printless />
    </StickyHeaderWrapper>
    <Icon data-printonly asset="logo" alt="BigO Tire" width={ 228 } height={ 27 } />
    <div data-max-width data-max-width-padding={ pathname !== '/' && pathname !== '/home' }>
      { genericMainContent }
    </div>
    { footer }
  </div>

OneColumnGenericPage.propTypes = {
  pathname: PropTypes.string,
  placeholders: PropTypes.shape({
    genericMainContent: PropTypes.element,
    footer: PropTypes.array,
    header: PropTypes.array,
    mainContent: PropTypes.array
  })
}

export default OneColumnGenericPage
